import { Button, Col, Empty, Menu, notification, Row, Space, Spin, Tooltip } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { MdPostAdd } from 'react-icons/md'
import { LoadingOutlined } from '@ant-design/icons';
import { GrFormAdd, GrFormSubtract } from 'react-icons/gr'
import './style.css'
import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack5';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import AddPolicy from './AddPolicy'
import { DeletePolicyApi, GetPolicyMenuItemsApi, GetPolicyNamesApi } from '../../../Services/CompanyPolicies'
import { createPolicyMenuItems } from '../../../Services/GeneralFunctions'
import { GetDropDownApi } from '../../../Services/CommonApis'

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


export default function CompanyPolicies({isAdmin, type}) {
    const [ api, contextHolder ] = notification.useNotification();

    const initialRender = useRef(true);

    const [ current, setCurrent ] = useState(null);
    const [ menuItems, setMenuItems ] = useState([]);
    const [ pdfUrl, setPdfUrl ] = useState(null);

    const [ pageNumber, setPageNumber ] = useState(null);
    const [ pageScale, setPageScale ] = useState(1);

    const [ policyNameDropDown, setPolicyNameDropDown ] = useState([]);

    const [ addPolicyToggle, setAddPolicyToggle ] = useState(false);

    const [ menuLoader, setMenuLoader ] = useState(false);
    const [ enableAddButton, setEnableAddButton ] = useState(false);

    const getMenuItems = async () => {
        try {
            setMenuLoader(true);
            const data = await GetPolicyMenuItemsApi(type);
            setMenuLoader(false);

            if ( data.data.success ) {
                setMenuItems(createPolicyMenuItems(data.data.data, handleDelete, isAdmin));
                getPolicyNames();
                setPdfUrl(null);
                setPageNumber(null);
                setCurrent(null);
            }
            else {
                api.error({
                    message: 'Error while Fetching Policies',
                    description: data.data.message,
                    placement: 'top'
                })
            }
        }
        catch (err) {
            setMenuLoader(false);
            api.error({
                message: err.message,
                description: 'Try to check your Internet Connection.',
                placement: 'top'
            });
        }
    }

    const getPolicyNames = async () => {
        setEnableAddButton(false);
        const data = await GetPolicyNamesApi();
        setEnableAddButton(true);

        if (data.data.success) {
            setPolicyNameDropDown(data.data.data.map((val) => ({label: val, key: val})));
        }
        else {
            api.error({
                message: 'Error while Fetching Policy Names',
                description: data.data.message,
                placement: 'top'
            });
        }
    }

    

    const handleDelete = async (id, name) => {
        try {
            const data = await DeletePolicyApi(id); 

            getMenuItems();
            api.success({
                description: `${name} Deleted Successfully!`,
                placement: 'top'
            });
        }
        catch (err) {
            api.error({
                message: err.message,
                description: 'Try to check your Internet Connection.',
                placement: 'top'
            });
        }
    }

    const onMenuClick = ({item, key}) => {
        setCurrent(key);
        setPdfUrl(item.props.url);
    }

    useEffect(() => { 
        if (initialRender.current) {
            initialRender.current = false;
            getMenuItems();
        }
    });

    useEffect(() => { 
        getMenuItems();
    }, [type]);

  return (
    <>
    {contextHolder}
    <AddPolicy open={addPolicyToggle} onClose={() => setAddPolicyToggle(false)} policyNames={policyNameDropDown} getMenuItems={getMenuItems} />

    <Row className='py-2 px-3 mb-3 box-shadow default-background-color align-items-center justify-content-between'  style={{ borderRadius: '10px', minHeight: '59px'}}>
        <p className='m-0'>
            <span className='fs-5 mr-2'>Policies & SOPs</span>
            <span className='fs-6 text-secondary'>/  {type}</span>
        </p>
        { isAdmin && <Col className='p-1' xxl={2} xl={3} lg={4} md={5} sm={6} xs={6}>
            { enableAddButton && <div className='action-button bg-secondary bs-opacity-75 bg-gradient text-center' style={{width: '100%'}} onClick={() => setAddPolicyToggle(true)}><MdPostAdd className='fs-5 fw-bold mx-1 mb-1' /><span className='fw-bold'>Add</span></div> }
        </Col>}
    </Row>

    <Row className='box-shadow bg-light justify-content-center align-content-start round-edges px-3 py-2 mb-2 ' style={{height: window.innerWidth>767 ?'calc( 100vh - 157px )' : '100%', minHeight: 'calc( 100vh - 157px )'}}>
        <Col className='text-center py-4' style={{overflow: 'auto', maxHeight: '100%', height: 'min-content'}} md={6} sm={24} xs={24}>
            { !menuLoader ?
                <Menu className='custom-menu custom-menu-title-background text-start' style={{height: 'min-content'}} onClick={onMenuClick} selectedKeys={[current]} mode="inline" items={menuItems} /> :
                <Spin className='my-4' size='large' indicator={<LoadingOutlined className='text-dark' />} spinning={true}/>
            }
        </Col>
        <Col className='px-3 position-relative' style={{height: '100%', maxHeight: '100%', minHeight: '300px'}} md={18} sm={24} xs={24}>
            <Row className='justify-content-center align-items-center align-content-center' style={{width: '100%', height: '100%', maxHeight: '100%', minHeight: '300px', borderLeft: window.innerWidth>767 ? '1px solid #00000014' : 'none', borderTop: window.innerWidth>767 ? 'none' : '1px solid #00000014'}}>
                {pdfUrl ? 
                    <Document 
                        className='custom-pdf-viewer'
                        file={pdfUrl} 
                        loading={<Spin size='large' indicator={<LoadingOutlined className='text-dark' />} spinning={true}/>}
                        onLoadSuccess={({numPages}) => setPageNumber(numPages)} 
                        noData={<Empty style={{transform: 'translateY(50vh - 50%)'}} />}
                    >
                        {Array.from(
                            new Array(pageNumber),
                            (el, index) => (
                            <Page
                                className='my-3'
                                scale={pageScale}
                                key={`page_${index + 1}`}
                                pageNumber={index + 1}
                            />
                            ),
                        )}
                    </Document> :
                    <Empty />
                }
            </Row>
            <Tooltip overlayInnerStyle={{color: 'black'}} title={`${Math.round(pageScale * 100)}%`} color='#ffffff' key='1'>
                <Space.Compact className='position-absolute top-0 end-0 py-2'>
                    <Button onClick={() => setPageScale(pageScale>0.2 ? pageScale - 0.1 : 0.1)}><GrFormSubtract className='fs-5' /></Button>
                    <Button onClick={() => setPageScale(pageScale + 0.1)}><GrFormAdd className='fs-5' /></Button>
                </Space.Compact>
            </Tooltip>
        </Col>
    </Row>
    </>
  )
}
